import React from 'react';
import Titlebar from '../Titlebar';
import Settingsdiv from './Settingsdiv';
import Settingsdiv2 from './Settingsdiv2';
import Navbar from '../Navbar';
import { Button, Input, Select } from 'antd';
import { Option } from 'antd/es/mentions';

function Projectsettings() {
  return (
    <div className='p-5 lg:w-96 m-auto bg-[#F2F2F2] h-screen'>
      <div className='ml-[-20px]'> <Navbar addlink={"/addproject"} /> </div>
      <Titlebar title={"Projects"} addlink="/" funcclik={""} />


      <div>
        <h3 className='text-[#888888] text-[12px]'> All Packages </h3>
        <div className='grid grid-cols-2  gap-x-4 gap-y-[0]'>
          <Settingsdiv2 title={"Package 1"} img={"images/Layer_1 (1).svg"} />
          <Settingsdiv2 title={"Web Package"} img={"images/Icon Container.svg"} />

          <Settingsdiv2 title={"Marketing Package"} img={"images/Capa_1 (1).svg"} />
          <Settingsdiv2 title={"New Year package"} img={"images/Capa_1.svg"} />

          <Settingsdiv2 title={"Package 1"} img={"images/Layer_1 (1).svg"} />
          <Settingsdiv2 title={"Web Package"} img={"images/Icon Container.svg"} />

          <Settingsdiv2 title={"Marketing Package"} img={"images/Capa_1 (1).svg"} />
          <Settingsdiv2 title={"New Year package"} img={"images/Capa_1.svg"} />




        </div>


        {/* poping element to add package  */}

        <div className='bg-white p-5 rounded-t-lg'>

          <h3> Package </h3>
          <Input
            placeholder='Enter your package name'
          />
<div>
          <Select

          className='w-full'
            showSearch
            placeholder="Select a person"
            optionFilterProp="label"
            onChange={""}
            onSearch={""}
            options={[

              {
                value: 'jack',
                label: 'Jack',
              },
              {
                value: 'lucy',
                label: 'Lucy',
              },
              {
                value: 'tom',
                label: 'Tom',
              },
            ]}
          />
          </div>

<div>
          <Button className='w-full bg-[#13AE85]  ' > Add </Button>
          </div>

        </div>



      </div>
    </div>
  )
}

export default Projectsettings
